export { MonthAverage } from './MonthAverage';
